export const buildProductMenu = (list, url) => {
  let productsCategory = Object.keys(list)
    .map(category => {
      let baseUrl = `${url}/${encodeURIComponent(category)}`
        , subItems = list[category].map(product => {
          let productURL = `${url}/${encodeURIComponent(category)}/${encodeURIComponent(product.nmDroga)}`
          return {
            'title': product.nmDroga,
            'url': productURL,
          }
        })
      return {
        'title': category,
        'url': baseUrl,
        'subItems': subItems
      }
    })
  return productsCategory
}